import { apolloClient } from '~/apollo-client';
import { GENERATE_IL_DISCLOSURE_FORMS } from './generate-il-disclosure-forms.queries';

interface GenerateIlDisclosureFormsParams {
  planId: number;
  redirectUri?: string;
}

export interface GenerateIlDisclosureFormsResponse {
  enqueued: boolean;
  planId: number;
}

export const generateIlDisclosureForms = async (
  params: GenerateIlDisclosureFormsParams,
): Promise<GenerateIlDisclosureFormsResponse> => {
  const { data } = await apolloClient.mutate<
    { generateIlDisclosureForms: GenerateIlDisclosureFormsResponse },
    { planId: number; redirectUri?: string }
  >({
    mutation: GENERATE_IL_DISCLOSURE_FORMS,
    variables: {
      planId: params.planId,
      ...(params.redirectUri ? { redirectUri: params.redirectUri } : {}),
    },
  });

  const result = data?.generateIlDisclosureForms;
  if (!result) {
    throw new Error('Failed to enqueue IL disclosure forms generation');
  }
  return result;
};
